<script lang="ts">
import { defineComponent } from 'vue';
import router from '../../router';
import { InteractiveContentPictureCounts } from '@/models/index';

export default defineComponent({
  name: 'Ios',
  data () {
    return {
      count: 0
    };
  },
  created () {
    const imageURL = require('../../assets/thumbnails/Day2Thumbnail.png');
    window.parent.postMessage(
      {
        solutoCampaign: {
          title: 'スマホの「困った・・・」を解決、「おもしろい！」につながるヒントをご提案',
          imageUrl: imageURL
        }
      }, '*'
    );
  },
  methods: {
    gotoInteractive () {
      router.push({ path: '/interactive/rule-of-third', query: { type: 'ios', version: '2' } });
    },
    onImgLoad () {
      this.count++;
      if (this.count === InteractiveContentPictureCounts.newContent) {
        this.$emit('scroll');
        this.$emit('load');
      }
    }
  }
});
</script>

<template>
   <main class="main" id="main">
      <div class="wrap__manual">
        <!-- ファーストビューエリア-->
        <section class="header__manual">
          <div class="section_inner__manual">
            <figure><img class="img__header__manual header-title-margin" @load="onImgLoad" src="../../assets/recommendation/title_image.png" alt=""/></figure>
            <figure><img class="img__header__manual" @load="onImgLoad" src="../../assets/recommendation/manual-01_kv.gif" alt=""/></figure>
            <p class="text__manual">『使い方サポート』のお知らせでお届けするコンテンツは、みなさまのスマホ利用に役立つヒントを数多く盛り込み、通信やテクノロジーとともにある日々の暮らしをサポートします。ここでは、その一例となるコンテンツをご紹介します。</p>
          </div>
        </section>
        <!-- End ファーストビューエリア-->
        <div class="contents__manual is-color-purple">
        <section class="section__manual section__manual__mv">
          <div class="inner__manual">
            <!-- ▽ header H1 ▽ -->
            <h1 class="ttl__h1__manual">上手にスマホで撮影するなら基本の写真テク「三分割法」</h1>
            <!-- ▽ MV Image ▽ -->
            <div class="mv__manual"><img @load="onImgLoad" src="../../assets/recommendation/manual-02_img1.png" alt=""/></div>
            <!-- ▽ Text ▽-->
            <p class="txt__manual">被写体を中央に置いてしまい、どこか味気ない写真に毎回なってしまう…。スマートフォンでも写真の基本はかわりません。一歩グレードアップさせるなら「三分割法」をマスターするのがおすすめです。</p>
          </div>
        </section>
        <section class="section__manual section__manual__default">
          <div class="inner__manual">
            <!-- ▽ header H2 ▽-->
            <h2 class="ttl__h2__manual">初心者でもプロ級になる<br/>「三分割法」とは？</h2>
            <!-- ▽ Text ▽-->
            <p class="txt__manual">三分割法とは写真の基本的な構図のひとつ。スマートフォンのカメラには、設定により三分割法に用いる格子線＝グリッドラインを表示する機能もあります。このグリッドラインを被写体の配置目安にすると絶妙なバランスの写真撮影ができて、「これ、プロに撮ってもらったの？」と評価されるかもしれませんよ。</p>
          </div>
        </section>
        <section class="section__manual section__manual__default section__manual__colored">
          <div class="arrow_box">まずは実践！<br/>ゲーム感覚で三分割法を体験してみよう！</div>
          <div class="img__manual"><img @load="onImgLoad" src="../../assets/recommendation/manual-02_img2.png" alt=""/></div>
          <!-- ▽ Conversion Button ▽-->
          <div class="conversion__btn__manual" @click="gotoInteractive()"> <a href="">チャレンジ</a></div>
        </section>
      </div>
        <section class="footer__manual">
          <div class="section_inner__manual">
            <h2 class="ttl__manual">スマホの楽しさ、もっと広がる。</h2>
            <p>このように、これから始まる新しいスマートフォンとの生活をより楽しく、より快適にしてくれるヒントをさまざまな記事でご紹介していきます。【使い方サポート】がお届けするコンテンツの代表例をはじめ、あなたの暮らしがより快適になる今後の出会いにご期待ください。</p>
          </div>
        </section>
      </div>
    </main>
</template>

<style lang="scss" scoped>
@import "@/styles/manual_notice.scss";
.header-title-margin {
  margin-bottom: 18px,
}
</style>
